<template>
  <div class="modal__footer">
    <div
      v-if="showCompositionNote"
      class="modal__note modal__note--footer"
    >
      * Полный состав см на этикетке продукции
    </div>
    <div v-if="hasLinksSection" class="modal__links">
      <h3 class="modal__part-title">Выберите интернет-магазин:</h3>
      <div class="modal__links-buttons">
        <div
          v-if="productLinks.auchan"
          class="modal__link-button img-w"
          @click="showPopup(productLinks.auchan)"
        >
          <img src="@/assets/img/links/auchan.png" alt="" />
        </div>
        <div
          v-if="productLinks.vprok"
          class="modal__link-button img-w"
          @click="showPopup(productLinks.vprok)"
        >
          <img src="@/assets/img/links/vprok.png" alt="" />
        </div>
        <div
          v-if="productLinks.perekrestok"
          class="modal__link-button img-w"
          @click="showPopup(productLinks.perekrestok)"
        >
          <img src="@/assets/img/links/perekrestok.png" alt="" />
        </div>
        <div
          v-if="showDeliveryLinks && metro"
          class="modal__link-button modal__link-button--text"
          @click="showPopup(metro)"
        >
          Metro
        </div>
        <div
          v-if="showDeliveryLinks && selgros"
          class="modal__link-button modal__link-button--text"
          @click="showPopup(selgros)"
        >
          Selgros
        </div>
      </div>
    </div>

    <!-- <div class="modal__starred-text">* Полный состав смотрите на этикетке продукции</div> -->
  </div>
</template>

<script>
const EMPTY_LINKS = {
  auchan: '',
  vprok: '',
  perekrestok: '',
};

export default {
  data() {
    return {
      links: [
        EMPTY_LINKS,
        {
          auchan: 'https://www.auchan.ru/product/gm_sokosoderzhnappalpi_045/',
          vprok: 'https://www.vprok.ru/product/pulpy-dob-napit-sokos-apel-s-myak-det-pit-450ml--309645?searchPhrase=pulpy',
          perekrestok: 'https://www.perekrestok.ru/cat/425/p/napitok-sokosoderzasij-pulpy-apelsin-450ml-3418780',
        },
        {
          auchan: 'https://www.auchan.ru/product/napitok-sokosoderzhashchiy-dobryy-pulpy-tropicheskiy-s-myakotyu-450-ml/',
          vprok: 'https://www.vprok.ru/product/pulpy-dobr-nap-pulpy-trop-sokos-s-ap-myak0-45l--309671?searchPhrase=pulpy',
          perekrestok: 'https://www.perekrestok.ru/cat/425/p/napitok-sokosoderzasij-pulpy-tropiceskij-s-makotu-450ml-3444876',
        },
        {
          auchan: 'https://www.auchan.ru/product/napitok-pulpy-dobryy-s-marakuyey-guavoy-i-kokosom-450-ml/',
          vprok: 'https://www.vprok.ru/product/pulpy-dobr-nap-sokkus-kok-jele-0-45l--692321?searchPhrase=pulpy',
          perekrestok: 'https://www.perekrestok.ru/cat/425/p/napitok-sokosoderzasij-pulpy-marakua-guava-kokos-450ml-3947130',
        },
        {
          auchan: 'https://www.auchan.ru/product/napitok-pulpy-dobryy-ananas-mango-450-ml/',
          vprok: 'https://www.vprok.ru/product/pulpy-dobr-nap-palpi-vk-anman-0-45l--501169?searchPhrase=pulpy',
          perekrestok: 'https://www.perekrestok.ru/cat/425/p/napitok-sokosoderzasij-pulpy-ananas-mango-450ml-3671718',
        },
        {
          auchan: 'https://www.auchan.ru/product/napitok-pulpy-dobryy-s-klubnikoy-arbuzom-i-aloe-450-ml/',
          vprok: 'https://www.vprok.ru/product/pulpy-dobr-nap-sokkus-aloe-v-0-45l--692320?searchPhrase=pulpy',
          perekrestok: 'https://www.perekrestok.ru/cat/425/p/napitok-sokosoderzasij-pulpy-klubnika-arbuz-s-kusockami-aloe-450ml-3947129',
        },
        EMPTY_LINKS,
      ],
    };
  },
  name: 'ModalFooter',

  props: {
    metro: {
      type: String,
      default: '',
    },
    selgros: {
      type: String,
      default: '',
    },
    id: {
      type: [Number, String],
      default: 1,
    },
    showCompositionNote: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    productOrder() {
      return Number(this.id) || 0;
    },
    productLinks() {
      return this.links[this.productOrder] || EMPTY_LINKS;
    },
    hasRetailLinks() {
      const { auchan, vprok, perekrestok } = this.productLinks;

      return !!(auchan || vprok || perekrestok);
    },
    showDeliveryLinks() {
      return !this.hasRetailLinks && !!(this.metro || this.selgros);
    },
    hasLinksSection() {
      return this.hasRetailLinks || this.showDeliveryLinks;
    },
  },

  methods: {
    showPopup(url) {
      const data = {
        val: true,
        url: url,
      };
      this.$store.commit('CHANGE_POPUP_VISIBILITY', data);
    },
  },
};
</script>

<style scoped lang="scss"></style>
